import type { UserProfile } from "@models/userProfile.model"
import { SOFT_COMPLIANCE_CHECK_CUTOFF_DATE } from "@utils/constants.util"

export function isLegacyUser(profile: UserProfile | null): boolean {
	if (!profile?.registrationDate || !SOFT_COMPLIANCE_CHECK_CUTOFF_DATE)
		return false
	const registered = new Date(profile.registrationDate)
	if (Number.isNaN(registered.getTime())) return false
	return registered.getTime() < SOFT_COMPLIANCE_CHECK_CUTOFF_DATE.getTime()
}
